<template>
  <transition v-if="visibleLoginPage"  name="login-fade">
    <div class="page-login">
      <MultiModuleSelect v-if="showMultiModule"/>
      <LoginFeedback />
      <div class="multi-module-empty" @click="openMultiModule"></div>
      <iframe :src="loginUrl" style="width:100%;height:100%;" :allow="localNetworkAccess"></iframe>
    </div>
  </transition>
</template>

<script>
  import { API } from 'public/config'
  import MultiModuleSelect from '../components/multi-module-select.vue'
  import LoginFeedback from '../components/login-feedback.vue'
  import { getShowMultiModule } from '../utils'
  import { handleReceivedTokenMessaage } from '../layout/setup/login.js'
  export default {
    name: 'login',
    components: {
      MultiModuleSelect,
      LoginFeedback
    },
    data () {
      // 谷歌浏览器版本
      const version = +navigator.userAgent.replace(/^.*Chrome\/([\d]+).*$/, '$1')
      return {
        localNetworkAccess: version >= 142 ? 'local-network-access *' : '',
        loginUrl: `${API.login}?logintype=inline&service=${location.origin}/#/`,
        showMultiModule: false,
        clickNum: 0,
        visibleLoginPage: true // 是否显示当前登录页面，为了在自动登录时另外一个页签存在Token时场景上不显示该页面。直接使用Token自动登录
      }
    },
    created () {
      // 默认设置为显示，兜底
      this.changeVisibleLoginPage(true)
      // 自动登录广播处理Token时的回调参数
      const params = {
        // 自动登录广播处理设置完另外页签的Token时的回调，让此页面不可见。提升用户体验，否则会先看到登录页，再自动跳转到页面
        channelMessageCallback: () => this.changeVisibleLoginPage(false)
      }
      // 处理接收另外同源页签自动登录广播发送来的Token消息
      handleReceivedTokenMessaage(params)
    },
    mounted() {
      this.hasMultiModuleData()
    },
    methods: {
      // 判断session是否有泳道配置信息
      hasMultiModuleData() {
        this.showMultiModule = getShowMultiModule()
      },
      openMultiModule () {
        this.clickNum += 1
        if (this.clickNum >= 5) {
          this.clickNum = 0
          this.showMultiModule = true
        }
      },
      // 是否显示登录页面
      changeVisibleLoginPage (val) {
        this.visibleLoginPage = val
      }
    },
  }
</script>

<style lang="scss" scoped>
  .page-login {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: #ffffff;
    .multi-module-empty {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      width: 200px;
      height: 36px;
    }
  }

  .login-fade-leave-active {
    animation: fade-out-up 0.5s;
  }

  @keyframes fade-out-up {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      -webkit-transform: translate3d(0, -100%, 0);
      transform: translate3d(0, -100%, 0);
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/pages/login.vue